import React, { useState } from 'react';
import { apiFetch } from '../jscontrol/apiClient';
import '../css/Category.css';

const CategoryCreate = ({ categories, onClose, onSuccess }) => {
  const [form, setForm] = useState({
    CategoryName: '',
    ParentCategoryId: '',
    Description: '',
    ImageUrl: '',
    DisplayOrder: 0,
    IsActive: true,
  });
  const [saving, setSaving] = useState(false);
  const [formError, setFormError] = useState(null);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  };

  const handleSave = async () => {
    if (!form.CategoryName.trim()) {
      setFormError('Category Name is required.');
      return;
    }
    setSaving(true);
    setFormError(null);
    try {
      await apiFetch('/Category/Create', {
        method: 'POST',
        data: {
          CategoryName: form.CategoryName,
          ParentCategoryId: form.ParentCategoryId ? Number(form.ParentCategoryId) : null,
          Description: form.Description,
          ImageUrl: form.ImageUrl || '',
          DisplayOrder: Number(form.DisplayOrder),
          IsActive: form.IsActive,
          CreatedBy: 0,
        },
      });
      onSuccess('Category added successfully.');
    } catch (e) {
      setFormError(e.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div
      className="cat-modal-overlay"
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div className="cat-modal">
        <div className="cat-modal-header">
          <h5>Add Category</h5>
          <button className="cat-modal-close" onClick={onClose}>&times;</button>
        </div>

        <div className="cat-modal-body">
          {formError && (
            <div className="alert alert-danger py-2 mb-3">{formError}</div>
          )}

          <div className="form-group mb-3">
            <label className="form-label">
              Category Name <span className="text-danger">*</span>
            </label>
            <input
              className="form-control"
              name="CategoryName"
              value={form.CategoryName}
              onChange={handleChange}
              placeholder="Enter category name"
            />
          </div>

          <div className="form-group mb-3">
            <label className="form-label">Parent Category</label>
            <select
              className="form-control"
              name="ParentCategoryId"
              value={form.ParentCategoryId}
              onChange={handleChange}
            >
              <option value="">None (Top Level)</option>
              {categories.map(c => (
                <option key={c.CategoryId} value={c.CategoryId}>
                  {c.CategoryName}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group mb-3">
            <label className="form-label">Description</label>
            <textarea
              className="form-control"
              name="Description"
              value={form.Description}
              onChange={handleChange}
              rows={3}
              placeholder="Enter description"
            />
          </div>

          <div className="form-group mb-3">
            <label className="form-label">Display Order</label>
            <input
              className="form-control"
              type="number"
              name="DisplayOrder"
              value={form.DisplayOrder}
              onChange={handleChange}
              min={0}
            />
          </div>

          <div className="form-check mb-3">
            <input
              className="form-check-input"
              type="checkbox"
              name="IsActive"
              id="catCreateIsActive"
              checked={form.IsActive}
              onChange={handleChange}
            />
            <label className="form-check-label" htmlFor="catCreateIsActive">Active</label>
          </div>
        </div>

        <div className="cat-modal-footer">
          <button className="btn btn-light me-2" onClick={onClose}>
            Cancel
          </button>
          <button className="btn btn-primary" onClick={handleSave} disabled={saving}>
            {saving ? (
              <>
                <span className="spinner-border spinner-border-sm me-1" role="status"></span>
                Saving...
              </>
            ) : 'Add Category'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CategoryCreate;
